const routesStructure = {
    dados_empresa: {
        codigo: 1,
        nome: 'Dados da empresa',
        path: '/dados_empresa',
    },
    dados_beneficiario: {
        codigo: 2,
        nome: 'Dados de beneficiário',
        path: '/dados_beneficiario',
    },
    movimentacao_cadastral: {
        codigo: 3,
        nome: 'Movimentação cadastral',
        path: '/movimentacao_cadastral',
    },
    faturamento: {
        codigo: 4,
        nome: 'Faturamento',
        path: '/faturamento',
    },
    central_ajuda: {
        codigo: 5,
        nome: 'Central de ajuda',
        path: '/central_ajuda',
    },
    dados_contrato: {
        codigo: 7,
        nome: 'Dados do contrato',
        path: '/dados_contrato',
    },
    registro_acidentados: {
        codigo: 9,
        nome: 'Registro de Acidentados',
        path: '/registro_acidentados',
    },
    fale_conosco: {
        codigo: 6,
        nome: 'fale_conosco',
        path: '/fale_conosco',
    },
    historico_consultas: {
        codigo: 10,
        nome: 'Histórico de Consultas',
        path: '/historico_consultas'
    }
};

export { routesStructure };
